export const aiLogo = require('@/assets/transSave/resource/image/9f/54/9f6433bddcae42d5973a59a0c808bb54.png') 

export const blockchainLogo = require('@/assets/transSave/resource/image/13/f7/1309682e6526a809dbee84664ae7e3f7.png')

export const pmLogo = require('@/assets/transSave/resource/image/35/98/352e1cac17d5e7cca2ff843c21790a98.png')

export const aiLogoBg = require('@/assets/transSave/resource/image/85/88/857a6ceb24f680533a63e3dd57d37d88.png')

export const blockchainLogoBg = require('@/assets/transSave/resource/image/28/62/28b221f16066b34f47b0c62343f2cb62.png')

export const pmLogoBg = require('@/assets/transSave/resource/image/ae/e2/aec7c40524554074e22722c4a43106e2.png')

export const aiLogoBlack = require('@/assets/transSave/resource/image/a2/5b/a2e59062e2d74da046ff2111ea82815b.png')

export const blockchainLogoBlack = require('@/assets/transSave/resource/image/7b/de/7be080a1f1415cb074f217bef70cdcde.png')

export const pmLogoBlack = require('@/assets/transSave/resource/image/0c/c7/0cba0a7d52aaf83aac68f585beab54c7.png')

export const aiLogoGrey = require('@/assets/transSave/resource/image/6d/93/6df44a6fc0c52b289d7858dc94828b93.png')

export const blockchainLogoGrey = require('@/assets/transSave/resource/image/ee/30/ee0af9832ea3f8c666b615e48f168c30.png')

export const pmLogoGrey = require('@/assets/transSave/resource/image/65/87/6586578d75cbce302c712a81035f0487.png')

// 数字 id

export const one = require('@/assets/transSave/resource/image/fa/5b/faf58dd5c20263b8efdfbf995f6dc85b.png')

export const two = require('@/assets/transSave/resource/image/5e/ee/5eceb14e9ba6621f4ae9d3d4f4d69eee.png')

export const three = require('@/assets/transSave/resource/image/82/55/8285ca6d4fb1073a21e954c7b5ee6655.png')

export const four = require('@/assets/transSave/resource/image/51/7f/51b3f964eb3a59b75c8ca1fb6fe8117f.png')

export const five = require('@/assets/transSave/resource/image/9a/f0/9a5d5f9abca1468a318a6c15bf2ee3f0.png')

export const sex = require('@/assets/transSave/resource/image/96/c0/96cf5305905b8698f62e88dc5f2187c0.png')

export const seven = require('@/assets/transSave/resource/image/db/1b/dba8e1ec55957248f3f7e3f67b59a71b.png')

export const eight = require('@/assets/transSave/resource/image/74/bb/7448dfc26b67786bef973a779fea46bb.png')

export const nine = require('@/assets/transSave/resource/image/42/93/4226c5a8db4c6929fb4d6924cc25fe93.png')

export const ten = require('@/assets/transSave/resource/image/bf/yy/bf7f261ed84599a1fc56f5e6e7da57yy.png')

// 数字 id mobile版

export const oneMobile = require('@/assets/transSave/resource/image/ab/13/ab63fa9ace42009dc28b44e9492a5913.png')

export const twoMobile = require('@/assets/transSave/resource/image/30/4e/30d2ac8895d65f6820622d3946f93b4e.png')

export const threeMobile = require('@/assets/transSave/resource/image/bd/55/bd22a1c2eyyaa628ce9b7de63d793e55.png')

export const fourMobile = require('@/assets/transSave/resource/image/13/03/133dfc1bf26045821fae0e1d8b530603.png')

export const fiveMobile = require('@/assets/transSave/resource/image/b0/2e/b059c0482b3fd099c3702583864abc2e.png')

export const sexMobile = require('@/assets/transSave/resource/image/74/c4/74fd173354a84042d030518988d2aac4.png')

export const sevenMobile = require('@/assets/transSave/resource/image/9b/c2/9b653cfca709487e3ce74d47162152c2.png')

export const eightMobile = require('@/assets/transSave/resource/image/36/95/368a735a831d7f3852977e3f506fe695.png')

export const nineMobile = require('@/assets/transSave/resource/image/19/26/19e2bb3e130a0f1e7bde0b2e6fe09b26.png')

export const tenMobile = require('@/assets/transSave/resource/image/b7/d1/b7847f058694138880abde9e60edf9d1.png')
